import PaystackPop, { type PaystackTransactionResponse } from "@paystack/inline-js";
import type { PaymentSession } from "../types/api";

export function launchPaystackPopup(paymentSession: PaymentSession) {
  return new Promise<PaystackTransactionResponse>((resolve, reject) => {
    const popup = new PaystackPop();

    popup.resumeTransaction(paymentSession.accessCode, {
      onSuccess: (response) => resolve(response),
      onCancel: () => reject(new Error("Payment was cancelled before completion.")),
      onError: (error) => reject(new Error(error.message || "Could not load Paystack checkout.")),
    });
  });
}
